/**
 * Initializes every password field visibility toggle on the page (a page may
 * have more than one, e.g. new-password + confirm-password):
 * - Toggles between visible text and masked password input.
 * - Updates the aria-label based on current visibility state.
 */
export const initPasswordToggle = () => {
  const toggles = document.querySelectorAll('.devise-form-wrapper__password-toggle');

  for (const toggle of toggles) {
    const wrapper = toggle.closest('.devise-form-wrapper__password-field');
    const field = /** @type {HTMLInputElement} */(
      wrapper?.querySelector('.devise-form-wrapper__input')
    );

    if (wrapper && field) {
      toggle.addEventListener('click', () => {
        const visibleClass = 'devise-form-wrapper__password-field_visible';
        const isVisible = wrapper.classList.toggle(visibleClass);
        field.type = isVisible ? 'text' : 'password';
        const label = isVisible
          ? toggle.dataset.hideLabel
          : toggle.dataset.showLabel;
        toggle.setAttribute('aria-label', label);
      });
    }
  }
};
